// extracted by mini-css-extract-plugin
export default {"chartWrapper":"src-modules-account-institution-metrics-general-style__chartWrapper_kWWfk","chart":"src-modules-account-institution-metrics-general-style__chart_HkIbr"};